import moment from 'moment';

moment.locale('de');

export const getBirthdayFromMeta = (meta, returnString = true) => {
  if (
    typeof meta !== 'undefined' &&
    meta !== null &&
    typeof meta.date_of_birth !== 'undefined' &&
    meta.date_of_birth !== null &&
    typeof meta.date_of_birth.value !== 'undefined' &&
    meta.date_of_birth.value !== null &&
    meta.date_of_birth.value.length
  ) {
    let momentBirthday = moment(meta.date_of_birth.value, 'DD.MM.YYYY');

    if (momentBirthday.format() === 'Invalid date') {
      momentBirthday = moment(meta.date_of_birth.value, 'YYYY-MM-DD');
    }

    if (momentBirthday.format() === 'Invalid date') {
      return false;
    } else {
      if (returnString) {
        const date = `${momentBirthday.format('DD.MM.YYYY')}`;
        const diff = `(${moment().diff(momentBirthday, 'years')} Jahre)`;

        return `${date} ${diff}`;
      } else {
        return momentBirthday;
      }
    }
  }

  return false;
};

export default getBirthdayFromMeta;



// WEBPACK FOOTER //
// ./src/helpers/getBirthdayFromMeta.js